export default "/images/e50fc2d891e149620c614fc1ea90cdb5.avif";